import { useHttp } from "./useHttp";
import { useDispatch } from "react-redux";
import { createSetInspectionDataAction } from "../actions/dataActions";

export const useInspectionData = (params, dataFresh) => {
  const dispatch = useDispatch();
  const [data, loading, error] = useHttp(
    "inspections",
    "get",
    params,
    dataFresh
  );
  if (error) {
    throw Error("There was an error");
  }

  if (!loading && data !== null) {
    dispatch(createSetInspectionDataAction(data));
  }

  return !loading;
};
